// ============================================================================
// CANCUN100 — versionesCupon.js  (APP 2/32c · transición: conviven el cupón 2.0 y la versión anterior)
// ----------------------------------------------------------------------------
// Una sola bandera para quitar la versión anterior: MOSTRAR_VERSION_ANTERIOR = false.
// CUPON_ENVIO dice qué versión vive en la ruta de siempre (pdf_supabase_cliente), que es la que mandan el correo y WhatsApp
// al cliente: 'anterior' hasta que Marco diga; con 'nueva', el cupón 2.0 pasa a esa ruta.
// La versión nueva (2.0) siempre queda además en <reservas|cotizaciones>-v2/<FOLIO>.pdf del mismo bucket pdfs-cliente.
// ============================================================================
export const MOSTRAR_VERSION_ANTERIOR = true;
export const CUPON_ENVIO = 'anterior'; // 'anterior' | 'nueva'

export const BUCKET_CLIENTE = 'pdfs-cliente';
export const carpetaDe = (tipo) => (tipo === 'cotizacion' ? 'cotizaciones' : 'reservas');
export const rutaV2 = (tipo, folio) => `${carpetaDe(tipo)}-v2/${folio}.pdf`;
export const rutaPrincipal = (tipo, folio) => `${carpetaDe(tipo)}/${folio}.pdf`;
export const nombreArchivo = (folio, cliente, sufijo = '') => `${String(`${folio}${cliente ? ' ' + cliente : ''}${sufijo}`).replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim()}.pdf`;
